import { atom } from "jotai";
import { Device } from "../helpers/types";

export const devicesAtom = atom<Device[] | null>(null);